// Library methods
import { useContext, useMemo } from "react";

// MUI Components
import Grid from "@mui/material/Grid";

// Components
import EyeReport from "./EyeReport";

// Utilities
import { ReportEachSectionContext } from "../../../contexts/CommentContext";
import { ReportDataContext } from "../../../contexts/ReportDataContext";
import { examCardEnums } from "../../../enums";

const ColorVisionReport = () => {
  const sectionName = examCardEnums.COLOR_VISION.sectionName;
  const { reportData } = useContext(ReportDataContext);
  const {
    sectionId,
    sectionId2,
    examReport,
    examReport2,
    eyeReport,
    eyeReport2,
    duration,
    duration2,
    comments,
    comments2,
  } = reportData?.[sectionName] ?? {};

  const ReportSectionContent = useMemo(() => {
    return (
      <Grid container sx={{ display: "flex" }} columnSpacing={4}>
        {examReport && (
          <ReportEachSectionContext.Provider
            value={{
              sectionId,
              examReport,
              eyeReport,
              duration,
              comments,
            }}
          >
            <Grid item xs={12} lg={6} pt={4}>
              <EyeReport />
            </Grid>
          </ReportEachSectionContext.Provider>
        )}
        {examReport2 && (
          <ReportEachSectionContext.Provider
            value={{
              sectionId: sectionId2,
              examReport: examReport2,
              eyeReport: eyeReport2,
              duration: duration2,
              comments: comments2,
            }}
          >
            <Grid item xs={12} lg={6} pt={4}>
              <EyeReport />
            </Grid>
          </ReportEachSectionContext.Provider>
        )}
      </Grid>
    );
  }, [
    comments,
    comments2,
    duration,
    duration2,
    examReport,
    examReport2,
    eyeReport,
    eyeReport2,
    sectionId,
    sectionId2,
  ]);
  return <>{ReportSectionContent}</>;
};

export default ColorVisionReport;
